import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import "./style.css";
import { useHistory } from "react-router";
import serviceList from "../Service/services-list";

const pages = ["about", "services", "contact"];

function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = useState();
    const [anchorElServices, setAnchorElServices] = useState();

    const [homeClassName, setHomeClassName] = useState("inactive");
    const [aboutClassName, setAboutClassName] = useState("inactive");
    const [servicesClassName, setServicesClassName] = useState("inactive");
    const [contactClassName, setContactClassName] = useState("inactive");
    const [serviceClassName, setServiceClassName] = useState("single-service");
    const [expandedState, setExpandedState] = useState(false);

    const [backgroundClassName, setBackgroundClassName] = useState("home-bg");
    const [navText, setNavText] = useState(
        <h1>
            <div className="bg-span">Welcome to</div>
            <div className="bg-span">
                <strong className="bg-text-strong">Ng Dental Surgery</strong>
            </div>
            <div className="bg-span">in Klang, Selangor</div>
        </h1>
    );

    const history = useHistory();

    const [classState, setClassState] = useState("nav-top");

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleOpenServicesMenu = (event) => {
        setAnchorElServices(event.currentTarget);
    };

    const handleCloseServicesMenu = () => {
        setAnchorElServices(null);
    };

    const handleNav = (route) => {
        history.push(route);
    };

    useEffect(() => {
        if (history.location.pathname === "/") {
            setHomeClassName("my-active");
            setBackgroundClassName("home-bg");
            setNavText(
                <h1>
                    <div className="bg-span">
                        <strong className="bg-text-strong">Ng Dental Surgery</strong>
                    </div>
                </h1>
            );
        } else if (history.location.pathname === "/about") {
            setAboutClassName("my-active");
            setBackgroundClassName("about-bg");
            setNavText(
                <h1>
                    <div className="bg-span">
                        <strong className="bg-text-strong">The Ng Dental Family</strong>
                    </div>
                </h1>
            );
        } else if (history.location.pathname === "/contact") {
            setContactClassName("my-active");
            setBackgroundClassName("contact-bg");
            setNavText(
                <h1>
                    <div className="bg-span">
                        <strong className="bg-text-strong">
                            Request your <br /> appointment today
                        </strong>
                    </div>
                    <div className="bg-span">
                        <strong className="bg-text-strong" style={{ fontSize: "75%" }}>
                            <a href="tel:+60333721099">
                                <i className="fas fa-phone-alt" style={{ marginRight: "10px" }}></i>
                                03-3372 1099
                            </a>
                            <br />
                            {/* <a
                href="https://wa.me/60163349669"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp fa-lg" style={{marginRight:'10px'}}></i>
                012-345 6789
              </a> */}
                        </strong>
                    </div>
                </h1>
            );
        } else if (history.location.pathname.includes("/service")) {
            let serv = history.location.pathname.split("/")[2];
            serv = serviceList.find((e) => e.id === serv);
            setServicesClassName("my-active");
            setBackgroundClassName("service-bg");
            setNavText(
                <h1>
                    <div className="bg-span">
                        <strong className="bg-text-strong">{serv.header}</strong>
                    </div>
                    <div className="bg-span"></div>
                </h1>
            );
        }
    }, [history.location.pathname, homeClassName, aboutClassName, servicesClassName, contactClassName]);

    return (
        <div className={backgroundClassName}>
            <AppBar position="static" sx={{ backgroundColor: "transparent", color: "black" }}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            onClick={() => handleNav("/")}
                            sx={{
                                mr: 2,
                                display: { xs: "none", md: "flex" },
                                fontFamily: "Alex Brush",
                                fontWeight: 700,
                                letterSpacing: ".3rem",
                                color: "inherit",
                                textDecoration: "none",
                                fontSize: "xx-large",
                            }}
                        >
                            Ng Dental
                        </Typography>

                        <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: "block", md: "none" },
                                }}
                            >
                                <MenuItem key="about" onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center" sx={{ color: "black" }} onClick={() => handleNav("/about")}>
                                        ABOUT
                                    </Typography>
                                </MenuItem>
                                <MenuItem key="services" onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center" sx={{ color: "black" }} onClick={handleOpenServicesMenu}>
                                        SERVICES
                                    </Typography>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElServices}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "left",
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: "bottom",
                                            horizontal: "left",
                                        }}
                                        open={Boolean(anchorElServices)}
                                        onClose={handleCloseServicesMenu}
                                    >
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/rct");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            RCT
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/braces");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            BRACES
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/crowns");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            CROWNS
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/dentures");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            DENTURES
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/implants");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            IMPLANTS
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/veneers");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            VENEERS
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/whitening");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            WHITENING
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/extractions");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            EXTRACTIONS
                                        </MenuItem>
                                        <MenuItem
                                            onClick={(e) => {
                                                handleNav("/services/fillings");
                                                handleCloseServicesMenu();
                                            }}
                                        >
                                            FILLINGS
                                        </MenuItem>
                                    </Menu>
                                </MenuItem>
                                <MenuItem key="contact" onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center" sx={{ color: "black" }} onClick={() => handleNav("/contact")}>
                                        CONTACT
                                    </Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                        <Typography
                            variant="h5"
                            noWrap
                            component="a"
                            onClick={() => handleNav("/")}
                            sx={{
                                mr: 2,
                                display: { xs: "flex", md: "none" },
                                flexGrow: 1,
                                fontFamily: "Alex Brush",
                                fontWeight: 700,
                                letterSpacing: ".3rem",
                                color: "inherit",
                                textDecoration: "none",
                                fontSize: "large",
                            }}
                        >
                            Ng Dental
                        </Typography>
                        <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, justifyContent: "end" }}>
                            <Button
                                key="about"
                                onClick={() => {
                                    handleCloseNavMenu();
                                    handleNav("/about");
                                }}
                                sx={{ my: 2, color: "black", display: "block", fontSize: "small", fontFamily: "Sen" }}
                            >
                                ABOUT
                            </Button>
                            <Button
                                key="services"
                                onClick={handleOpenServicesMenu}
                                sx={{ my: 2, color: "black", display: "block", fontSize: "small", fontFamily: "Sen" }}
                            >
                                Services
                            </Button>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElServices}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                open={Boolean(anchorElServices)}
                                onClose={handleCloseServicesMenu}
                            >
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/rct");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    RCT
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/braces");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    BRACES
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/crowns");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    CROWNS
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/dentures");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    DENTURES
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/implants");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    IMPLANTS
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/veneers");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    VENEERS
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/whitening");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    WHITENING
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/extractions");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    EXTRACTIONS
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        handleNav("/services/fillings");
                                        handleCloseServicesMenu();
                                    }}
                                >
                                    FILLINGS
                                </MenuItem>
                            </Menu>
                            <Button
                                key="contact"
                                onClick={() => {
                                    handleCloseNavMenu();
                                    handleNav("/contact");
                                }}
                                sx={{ my: 2, color: "black", display: "block", fontSize: "small", fontFamily: "Sen" }}
                            >
                                CONTACT
                            </Button>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            <div className="bg-text">
                {navText}
                <hr className="bg-text-hr" />
            </div>
        </div>
    );
}
export default ResponsiveAppBar;
